/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetFavorites200ResponseAllOfData } from './GetFavorites200ResponseAllOfData';
import {
    GetFavorites200ResponseAllOfDataFromJSON,
    GetFavorites200ResponseAllOfDataFromJSONTyped,
    GetFavorites200ResponseAllOfDataToJSON,
} from './GetFavorites200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetFavorites200ResponseAllOf
 */
export interface GetFavorites200ResponseAllOf {
    /**
     * 
     * @type {GetFavorites200ResponseAllOfData}
     * @memberof GetFavorites200ResponseAllOf
     */
    data: GetFavorites200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetFavorites200ResponseAllOf interface.
 */
export function instanceOfGetFavorites200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetFavorites200ResponseAllOfFromJSON(json: any): GetFavorites200ResponseAllOf {
    return GetFavorites200ResponseAllOfFromJSONTyped(json, false);
}

export function GetFavorites200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFavorites200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetFavorites200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetFavorites200ResponseAllOfToJSON(value?: GetFavorites200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetFavorites200ResponseAllOfDataToJSON(value.data),
    };
}

